import { CloudOff } from 'lucide-react';
import { useSyncState } from '../../sync/useSync.js';
import { pluralise } from '../../lib/format.js';

/**
 * A single calm line, only while offline.
 *
 * The temptation is a red alert. But offline is the *expected* state in a die
 * store with a metre of concrete overhead - alarming people about the normal
 * case trains them to ignore the banner that will one day matter.
 */
export function OfflineBanner() {
  const { online, pending } = useSyncState();
  if (online) return null;

  return (
    <div
      role="status"
      className="safe-t flex shrink-0 items-center justify-center gap-2 bg-warning-subtle px-3 py-1.5 text-xs font-medium text-warning"
    >
      <CloudOff className="size-3.5 shrink-0" aria-hidden />
      <span>
        Working offline
        {pending > 0 ? ` - ${pluralise(pending, 'change')} will sync when you reconnect` : ''}
      </span>
    </div>
  );
}
